import { ModalActionDef, ModalDefine, ModalStatus } from '@/libs/formHelper/modalForm/type'
import { GenealogyApply } from '@/api/genealogy/GenealogyApply'

export default function getModalDefine (view: any): ModalDefine<GenealogyApply> {
  const items = [{
    title: '头像',
    type: {
      module: 'imageUrl'
    },
    key: 'avatar'
  }, {
    title: '姓名',
    col: { span: 12 },
    required: true,
    key: 'name'
  }, {
    title: '昵称',
    col: { span: 12 },
    required: true,
    key: 'nickname'
  }, {
    title: '性别',
    required: true,
    key: 'gender'
  }, {
    title: '电话',
    required: true,
    key: 'telPhone'
  }, {
    title: '身份证',
    required: true,
    key: 'identityNumber'
  }, {
    title: '状态',
    required: true,
    key: 'valid'
  }]

  const actions: ModalActionDef<GenealogyApply>[] = [{
    key: 'create',
    title: '创建',
    type: 'submit',
    button: 'success',
    actionClose: true,
    modalStatus: ModalStatus.ADD,
    onClick: (item: GenealogyApply) => {
      return view.onInsertItem(item)
    }
  }, {
    key: 'modi',
    title: '保存',
    type: 'submit',
    button: 'success',
    actionClose: true,
    modalStatus: ModalStatus.MODI,
    onClick: (item: GenealogyApply) => {
      return view.onUpdateItem(item)
    }
  }]

  return {
    items,
    actions
  }
}
